export const BASE_URL = "https://prod.malllogisticsapi.com/api"